module.exports = __webpack_public_path__ + "img/books.1ee13997.jpeg";